import API_CONFIG from '@/config';
import base from '@/plugins/baseHttp';
import { createService, createModule } from '@/models/core';

const configuration = {
  name: 'employee',
  type: 'node--employee',
  attributes: {
    title: {
      type: 'string',
      required: true,
      isArray: false,
      name: 'title',
    },
    apellidos: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'apellidos',
    },
    nombre: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'nomb',
    },
    telefono: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'telefono',
    },
  },
  relationships: {
    department: {
      type: 'node--document_type',
      required: false,
      isArray: false,
      name: 'department',
    },
    file: {
      type: 'file--file',
      required: false,
      isArray: false,
      name: 'file',
    },
    user: {
      type: 'user--user',
      required: false,
      isArray: false,
      name: 'user_ref',
    },
  },
};
export const EmployeeService = createService(base, configuration, API_CONFIG.API);
export const EmployeeModule = createModule(EmployeeService, true);



// WEBPACK FOOTER //
// ./src/models/employee.js